module.exports = __webpack_public_path__ + "assets/img/swiper-1-2.0caabdf8.jpg";